import {
  checkProximity,
  checkProximityWithOtherZones,
  checkZoneCrossOther,
  drawCoordinates,
  drawLineCoordinates,
  formatCoordinates,
} from "./drawFunctions";

function handleEditZone(
  id,
  setEditMode,
  setZoneBeingEdited,
  zones,
  setBackupCoord
) {
  setEditMode(true);

  setZoneBeingEdited(id);

  const zoneToEdit = zones.find((zone) => zone.id === id);

  const backup = zoneToEdit
    ? JSON.parse(JSON.stringify(zoneToEdit.coordinates))
    : [];
  setBackupCoord(backup);
}

function handleEditLine(
  id,
  setEditMode,
  setLineBeingEdited,
  lines,
  setBackupCoord
) {
  setEditMode(true);

  setLineBeingEdited(id);

  const lineToEdit = lines.find((line) => line.id === id);

  const backup = lineToEdit
    ? JSON.parse(JSON.stringify(lineToEdit.coordinates))
    : [];
  setBackupCoord(backup);
}

function handleMoveVertice(
  event,
  canvas,
  drawMode,
  zones,
  zoneBeingEdited,
  coordIndex,
  pointIndex,
  editMode,
  setZones,
  lines,
  lineBeingEdited,
  setLines,
  setZoneToPost
) {
  const rect = canvas.getBoundingClientRect();
  const context = canvas.getContext("2d");

  const mouse = formatCoordinates(canvas, rect, event.clientX, event.clientY);

  if (drawMode === "zone") {
    const copy_zones = [...zones];

    copy_zones.forEach((zone) => {
      if (zone.id === zoneBeingEdited) {
        if (checkProximityWithOtherZones(mouse, zones, zoneBeingEdited)) {
          return; // @PERIGO: PODE SER QUE AQUI DEU MERDA
        }
        zone.coordinates[coordIndex[0]][pointIndex[0]] = mouse;
        zone.coordinates[coordIndex[1]][pointIndex[1]] = mouse;
        setZoneToPost(zone);
      }
    });

    drawCoordinates(context, copy_zones, editMode, zoneBeingEdited, canvas);
    setZones(copy_zones);
  } else if (drawMode === "line") {
    const copy_lines = [...lines];
    let updatedLine = null;

    copy_lines.forEach((line) => {
      if (line.id === lineBeingEdited) {
        updatedLine = JSON.parse(JSON.stringify(line));

        if (coordIndex[0] === 0) {
          updatedLine.coordinates[0][pointIndex[0]] = mouse;
        }

        Object.assign(line, updatedLine);
      }
    });

    drawLineCoordinates(context, copy_lines, editMode, lineBeingEdited, canvas);
    setLines(copy_lines);

    if (updatedLine) {
      const formattedLine = {
        ...updatedLine,
        coordinates: updatedLine.coordinates[0].map((point) => [
          point.x,
          point.y,
        ]),
      };
      setZoneToPost(formattedLine);
    }
  }
}

function handleMoveVerticeClick(
  event,
  canvas,
  zones,
  coordIndex,
  setCoordIndex,
  setPointIndex,
  setIsPressed,
  drawMode,
  zoneBeingEdited,
  lines,
  lineBeingEdited
) {
  const rect = canvas.getBoundingClientRect();

  const mouse = formatCoordinates(canvas, rect, event.clientX, event.clientY);

  const list_coord_index = [];
  const list_point_index = [];

  if (coordIndex.length) {
    setCoordIndex([]);
    setPointIndex([]);
    setIsPressed(false);
    if (drawMode === "zone") {
      const this_zone = zones.find((zone) => zone.id === zoneBeingEdited);
      if (checkZoneCrossOther(this_zone, zones)) {
        alert("Zona cruzando outra zona!");
      }
    }
  } else {
    if (drawMode === "zone") {
      zones.forEach((zone) => {
        if (zone.id === zoneBeingEdited) {
          zone.coordinates.forEach((coord, coord_index) => {
            coord.forEach((point, point_index) => {
              if (checkProximity(mouse.x, mouse.y, point.x, point.y)) {
                list_coord_index.push(coord_index);
                list_point_index.push(point_index);
                setIsPressed(true);
              }
            });
          });
        }
      });
    } else if (drawMode === "line") {
      lines.forEach((line) => {
        if (line.id === lineBeingEdited) {
          line.coordinates.forEach((coord, coord_index) => {
            coord.forEach((point, point_index) => {
              if (checkProximity(mouse.x, mouse.y, point.x, point.y)) {
                list_coord_index.push(coord_index);
                list_point_index.push(point_index);
                setIsPressed(true);
              }
            });
          });
        }
      });
    }

    setCoordIndex(list_coord_index);
    setPointIndex(list_point_index);
  }
}

function handleCancelMoveVertice(
  setCancelEdit,
  drawMode,
  zones,
  zoneBeingEdited,
  backupCoord,
  setZones,
  lines,
  lineBeingEdited,
  setLines,
  setCoordIndex,
  setPointIndex
) {
  setCancelEdit(true);

  if (drawMode === "zone") {
    const copy_zones = zones.map((zone) => {
      if (zone.id === zoneBeingEdited) {
        return { ...zone, coordinates: backupCoord };
      }
      return zone;
    });
    setZones(copy_zones);
  } else if (drawMode === "line") {
    const copy_lines = lines.map((line) => {
      if (line.id === lineBeingEdited) {
        return { ...line, coordinates: backupCoord };
      }
      return line;
    });
    setLines(copy_lines);
  }

  setCoordIndex([]);
  setPointIndex([]);
}

export {
  handleEditZone,
  handleEditLine,
  handleMoveVertice,
  handleMoveVerticeClick,
  handleCancelMoveVertice,
};
